import { LinkChip, PageHeader } from '@loop3/ui'
import { SOLUTIONS_REPOSITORY_URL } from '@loop3/universe'
import { SolutionsLibrary } from '@/components/knowledge-hub/solutions-library'

/** Knowledge Hub sub-page: every solution and feature Loop3 has built, with search and filters. */
export function SolutionsLibraryPage() {
  return (
    <div className="mx-auto max-w-7xl pb-16">
      <PageHeader
        title="What Loop3 has built"
        subtitle="Every solution and feature in the repository, by client, capability and knowledge-loop stage. Synced every hour from Notion, where it is edited."
        actions={
          <LinkChip
            service="notion"
            href={SOLUTIONS_REPOSITORY_URL}
            label="Open in Notion"
          />
        }
      />
      <SolutionsLibrary />
    </div>
  )
}
